import React, { Component } from "react";
import { useState, useEffect, useCallback } from "react";
import MaterialTable from "@material-table/core";
import Footer from "../../components/shared/Footer";
import Select, { ActionMeta } from "react-select";
import * as APIModels from "../../models";
import {
    ReportService,
    SubmissionService,
} from "../../services/SubmissionService";
import AttorneySelect from "../../components/shared/AttorneySelect";
import { ExportPdf, ExportCsv } from "@material-table/exporters";
import moment from "moment";
import { ClientService } from "../../services/ClientService";
import { FileService } from "../../services/SubmissionService";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

type NameValueOptionType = { label: string; value: string };

export default function EFiling() {
    const [searching, setSearching] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const initialToDate = moment(Date.now()).toDate();
    const initialFromDate = moment(Date.now()).add(-1, "days").toDate();

    const [fromDateTime, setFromDateTime] = useState<Date>(initialFromDate);
    const [toDateTime, setToDateTime] = useState<Date>(initialToDate);

    const [reportRequest, setReportRequest] =
        useState<APIModels.EFileReportRequest>({
            toDate: initialToDate.toISOString().substring(0, 10),
            fromDate: initialFromDate.toISOString().substring(0, 10),
        });

    const [attorneyId, setAttorneyId] = useState("");
    const [firmId, setFirmId] = useState("");

    const [data, setData] = useState([] as APIModels.EFileReport[]);

    const searchByNameValues: NameValueOptionType[] = [
        {
            label: "None",
            value: "0",
        },
        {
            label: "Court Case Number",
            value: "1",
        },
        {
            label: "Uniform Case Number",
            value: "2",
        },
        {
            label: "Parties",
            value: "3",
        },
        {
            label: "County",
            value: "4",
        },
        {
            label: "Division",
            value: "5",
        },
        {
            label: "Portal Reference Number",
            value: "6",
        },
        {
            label: "Attorney",
            value: "7",
        },
        {
            label: "Tracking/Matter	",
            value: "8",
        },
        {
            label: "Filename",
            value: "9",
        },
    ];
    const [searchById, setSearchById] = useState("0");
    const [searchByOptions, setSearchByOptions] = useState(searchByNameValues);

    useEffect(() => {
        const toDateTimeISO = toDateTime.toISOString();
        const fromDateTimeISO = fromDateTime.toISOString();

        if (toDateTimeISO !== reportRequest.toDate) {
            setReportRequest(
                (prevReportRequest) =>
                    ({
                        ...prevReportRequest,
                        toDate: toDateTimeISO,
                    } as APIModels.EFileReportRequest)
            );
        }
        if (fromDateTimeISO !== reportRequest.fromDate) {
            setReportRequest(
                (prevReportRequest) =>
                    ({
                        ...prevReportRequest,
                        fromDate: fromDateTimeISO,
                    } as APIModels.EFileReportRequest)
            );
        }
        console.log({ turn_the_frogs_gay: reportRequest });
    }, [toDateTime, fromDateTime]);

    const onSearchByOptionChange = (
        value: NameValueOptionType | null,
        actionMeta: ActionMeta<NameValueOptionType>
    ) => {
        setSearchById(value!.value);
        if (value!.value === "0") {
            setReportRequest({
                ...reportRequest,
                searchBy: parseInt(value!.value),
                contains: "",
            });
        } else {
            setReportRequest({
                ...reportRequest,
                searchBy: parseInt(value!.value),
            });
        }
    };

    console.log(reportRequest.fromDate);
    console.log(reportRequest.toDate);

    const downloadFile = (fileId: string) => {
        const numericRepr = parseInt(fileId);

        if (isNaN(numericRepr)) {
            SubmissionService.get({
                id: fileId,
            }).then(
                (resp) => {
                    if (resp.data) {
                        resp.data.documents?.forEach((d) => () => {
                            FileService.get({
                                submissionId: resp.data!.id!,
                                documentId: d.filename!,
                                source: "",
                            }).then(
                                (resp) => {
                                    resp.json().then((json) => {
                                        const anchor =
                                            document.createElement("a");
                                        anchor.href = json.url;
                                        anchor.target = "blank";
                                        anchor.download = d.filename!;
                                        anchor.click();
                                    });
                                },
                                (error) => {
                                    console.log(error);
                                }
                            );
                        });
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        } else {
            SubmissionService.submissionByFileId({
                fileId: numericRepr,
                firmId: firmId,
            }).then(
                (resp) => {
                    if (resp.data) {
                        resp.data.documents?.forEach((d) => {
                            FileService.get({
                                submissionId: resp.data!.id!,
                                documentId: d.filename!,
                                source: "",
                            }).then(
                                (resp) => {
                                    console.log(resp);
                                    resp.json().then((json) => {
                                        const anchor =
                                            document.createElement("a");
                                        anchor.href = json.url;
                                        anchor.target = "_blank";
                                        anchor.download = d.filename!;
                                        anchor.click();
                                    });
                                },
                                (error) => {
                                    console.log(error);
                                }
                            );
                        });
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    // const onAttorneySelected = (id: string, name: string) => {
    //     setAttorneyId(id);
    // };

    const onFirmSelected = (id: string, name: string) => {
        setFirmId(id);
    };

    const onSearchClick = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setSearching(true);
        setErrorMessage("");
        let attId = "";
        ClientService.firmAttorneys({ firmId }).then((resp) => {
            if (resp.successful && resp.data) {
                attId = resp.data![0].id!;
                ReportService.getEFileReporting({
                    attorneyId: attId,
                    body: reportRequest,
                }).then(
                    (resp) => {
                        setSearching(false);
                        if (resp.successful === true) {
                            setData(resp.data as APIModels.EFileReport[]);
                            setErrorMessage(resp.errorMessage ?? "");
                        } else {
                            setErrorMessage(resp.errorMessage ?? "");
                        }
                    },
                    (error) => {
                        setSearching(false);
                        setErrorMessage("An error has occurred");
                    }
                );
            } else {
                setErrorMessage(resp.errorMessage ?? "");
            }
        });
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Reporting</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            Reporting
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        e-Filing
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <form action="#" onSubmit={onSearchClick}>
                    <div className="mb-3">
                        <AttorneySelect onFirmSelected={onFirmSelected} />
                    </div>
                    <div className="row mb-3">
                        <div className="col-6 ">
                            <label htmlFor="txtFrom" className="form-label">
                                From:
                            </label>
                            <div className="input-group">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="txtFrom"
                                    required
                                    aria-describedby="inputGroupPrepend"
                                    value={reportRequest.fromDate}
                                    onChange={(event) =>
                                        setReportRequest({
                                            ...reportRequest,
                                            fromDate: event.currentTarget.value,
                                        })
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <label htmlFor="txtTo" className="form-label">
                                To:
                            </label>
                            <div className="input-group">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="txtTo"
                                    required={true}
                                    aria-describedby="inputGroupPrepend"
                                    value={reportRequest.toDate}
                                    onChange={(event) =>
                                        setReportRequest({
                                            ...reportRequest,
                                            toDate: event.currentTarget.value,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <label
                                htmlFor="selectSeachBy"
                                className="form-label"
                            >
                                Search By:
                            </label>

                            <Select
                                id="selectSeachBy"
                                name="selectSeachBy"
                                styles={{
                                    // Fixes the overlapping problem of the component
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                    }),
                                }}
                                value={searchByOptions.filter(
                                    (c) => c.value === searchById
                                )}
                                options={searchByOptions}
                                onChange={onSearchByOptionChange}
                            />
                        </div>
                        <div className="col-6">
                            <label htmlFor="txtContains" className="form-label">
                                Contains:
                            </label>
                            <div className="input-group">
                                {searchById === "0" ? (
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="txtContains"
                                        aria-describedby="inputGroupPrepend"
                                        defaultValue={""}
                                        disabled
                                        value={reportRequest.contains}
                                        onChange={(event) =>
                                            setReportRequest({
                                                ...reportRequest,
                                                contains:
                                                    event.currentTarget.value,
                                            })
                                        }
                                    />
                                ) : (
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="txtContains"
                                        aria-describedby="inputGroupPrepend"
                                        onChange={(event) =>
                                            setReportRequest({
                                                ...reportRequest,
                                                contains:
                                                    event.currentTarget.value,
                                            })
                                        }
                                        required={true}
                                    />
                                )}

                                <div className="invalid-feedback">
                                    Please provide a valid bar number.
                                </div>
                            </div>
                        </div>
                        <div className="text-end mb-3">
                            {searching ? (
                                <button
                                    className="btn btn-primary waves-effect waves-light mt-2"
                                    type="button"
                                    disabled={true}
                                >
                                    <span
                                        className="spinner-border spinner-border-sm me-1"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Searching...
                                </button>
                            ) : (
                                <button
                                    className="btn btn-primary waves-effect waves-light mt-2"
                                    type="submit"
                                    // onClick={onSearchClick}
                                >
                                    Search
                                </button>
                            )}
                            <div style={{ color: "red" }}>{errorMessage}</div>
                        </div>
                    </div>
                </form>

                <div className="row">
                    <div className="col-12">
                        <div style={{ maxWidth: "100%" }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <MaterialTable
                                    columns={[
                                        { title: "NO", field: "NO" },
                                        {
                                            title: "CRT_CASE_NO",
                                            field: "CRT_CASE_NO",
                                        },
                                        {
                                            title: "UCN",
                                            field: "UCN",
                                            headerStyle: {
                                                whiteSpace: "nowrap",
                                                textAlign: "center",
                                            },
                                            cellStyle: {
                                                whiteSpace: "nowrap",
                                                textAlign: "center",
                                            },
                                        },
                                        {
                                            title: "PARTIES",
                                            field: "PARTIES",
                                            cellStyle: {
                                                whiteSpace: "nowrap",
                                                textAlign: "center",
                                            },
                                        },
                                        {
                                            title: "NO_DOCS_FILED",
                                            field: "NO_DOCS_FILED",
                                            cellStyle: {
                                                textAlign: "center",
                                            },
                                        },
                                        {
                                            title: "DATE_FILED",
                                            field: "DATE_FILED",
                                            type: "datetime",
                                            dateSetting: {
                                                format: "DD/MM/yyyy HH:MM:ss",
                                            },
                                            exportTransformer: (
                                                row: APIModels.EFileReport
                                            ) =>
                                                dayjs(row.DATE_FILED)
                                                    .tz("America/New_York") // Set the timezone to New York
                                                    .format(
                                                        "YYYY-MM-DD HH:mm:ss"
                                                    ), // Format the output to your desired format
                                        },
                                        {
                                            title: "PORTAL_REF_NO",
                                            field: "PORTAL_REF_NO",
                                        },
                                        {
                                            title: "ATTORNEY",
                                            field: "ATTORNEY",
                                        },
                                        {
                                            title: "FILENAME",
                                            field: "FILENAME",
                                            render: (rowData) => (
                                                <a
                                                    style={{
                                                        cursor: "pointer",
                                                        color: "#526dee",
                                                    }}
                                                    onClick={() =>
                                                        downloadFile(
                                                            rowData.NO as string
                                                        )
                                                    }
                                                >
                                                    {rowData.FILENAME}
                                                </a>
                                            ),
                                        },
                                        { title: "COUNTY", field: "COUNTY" },
                                        {
                                            title: "DIVISION",
                                            field: "DIVISION",
                                        },
                                        {
                                            title: "TRACKING",
                                            field: "TRACKING",
                                        },
                                        {
                                            title: "FINALFEES",
                                            field: "FINALFEES",
                                            cellStyle: {
                                                whiteSpace: "nowrap",
                                                textAlign: "center",
                                            },
                                        },
                                        { title: "SERVICE", field: "SERVICE" },
                                        { title: "TYPE", field: "TYPE" },
                                        { title: "NOTES", field: "NOTES" },
                                    ]}
                                    data={data}
                                    title="e-Filing Report"
                                    options={{
                                        exportAllData: true,
                                        exportMenu: [
                                            {
                                                label: "Export CSV with uppercase names",
                                                exportFunc: (cols, datas) =>
                                                    ExportCsv(
                                                        cols,
                                                        datas,
                                                        `EFileReport-${dayjs(
                                                            Date.now()
                                                        ).format("DD-MM-YY")}`
                                                    ),
                                            },
                                        ],
                                        tableLayout: "auto",
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
